import PharmaGenesText from './PharmaGenesText';
import PharmaGenesCard from './PharmaGenesCard';
import SectionStructure from '../../../../../components/Section/SectionStructure';
import DrugButtonGroup from '../ButtonGroup/DrugButtonGroup';


export default function SectionPharmaGenes() {

    
return (

<SectionStructure
    
    sectiontext=    {  <PharmaGenesText />  }
    sectiondiagroup=    { <DrugButtonGroup />} 

    sectioncards=  { <PharmaGenesCard /> }
    
        
    />          
    )
}